export const GET_USERS = 'GET_USERS';
export const DELETE_USER = 'DELETE_USER';
export const SELECT_USER = 'SELECT_USER';
